export default {
  "calendly": "_calendly_199axp"
};
